// Always renders a redaction marker regardless of value. Used for PII
// columns where the partner returns the value but Valet's policy is to
// show a placeholder. Defense in depth — server-side validation also
// strips PII columns before they reach the renderer.
export function RedactedCell() {
  return <span className="text-app-subtle">&lt;redacted&gt;</span>
}
